import classnames from 'classnames/bind'
import Clipboard from 'clipboard'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { IS_IE } from 'supports/user_agent_helper'
import styles from './button_for_copy.module.scss'

const cx = classnames.bind(styles)

const ToolTip = ({ placement, show }) => {
  if (!show) {
    return null
  }

  return (
    <div className={cx(styles.tip, { tipBottom: placement === 'bottom', tipTop: placement !== 'bottom' })}>
      {I18n.t('components.button_for_copy.message.copy.complete')}
    </div>
  )
}

ToolTip.propTypes = {
  placement: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired
}

export default class ButtonForCopy extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showTooltip: false,
      isSupported: Clipboard.isSupported()
    }
  }

  componentDidMount() {
    const { target } = this.props
    const { isSupported } = this.state

    if (isSupported) {
      // IEではtargetの場合に範囲選択がうまく作動せず、textでは取得できます
      // IE以外ではtextではコピーされず、targetで取得できるので、IEとそれ以外で条件を変えています
      if (IS_IE) {
        this.clipboard = new Clipboard(this.button, {
          text: () => target().value
        })
      } else {
        this.clipboard = new Clipboard(this.button, {
          target
        })
      }

      this.clipboard.on('success', e => {
        e.clearSelection()
        this.showTooltip()
      })
      this.clipboard.on('error', () => {
        this.hideTooltip()
      })
    }
  }

  componentWillUnmount() {
    if (!isEmpty(this.clipboard)) {
      this.clipboard.destroy()
    }
  }

  showTooltip() {
    this.setState({
      showTooltip: true
    })
  }

  hideTooltip() {
    this.setState({
      showTooltip: false
    })
  }

  // clipboardが使えない場合は要素を選択する
  handleFocus() {
    const { target } = this.props

    target().focus()
    target().select()
  }

  handleHideTooltip() {
    setTimeout(() => {
      this.hideTooltip()
    }, 1000)
  }

  render() {
    const { className, fallbackTitle, title, toolTipPlacement } = this.props
    const { showTooltip, isSupported } = this.state

    // clipborad未サポート & 選択もできない
    if (!isSupported && fallbackTitle === null) {
      return null
    }

    // clipboard未サポート
    if (!isSupported) {
      return (
        <button type="button" className={className} onClick={() => this.handleFocus()}>
          <i className="ic-copy" />
          {fallbackTitle}
        </button>
      )
    }

    // clipboradサポート
    return (
      <button
        type="button"
        ref={ref => {
          this.button = ref
        }}
        className={className}
        onMouseLeave={() => this.handleHideTooltip()}
        onTouchEnd={() => this.handleHideTooltip()}
      >
        <i className="ic-copy" />
        {title}
        <ToolTip show={showTooltip} placement={toolTipPlacement} />
      </button>
    )
  }
}

ButtonForCopy.propTypes = {
  className: PropTypes.string,
  fallbackTitle: PropTypes.string,
  target: PropTypes.func.isRequired,
  title: PropTypes.string,
  toolTipPlacement: PropTypes.string
}

ButtonForCopy.defaultProps = {
  className: null,
  fallbackTitle: null,
  title: null,
  toolTipPlacement: 'bottom'
}
